import React from 'react'

const SidebarContext = React.createContext({
    sidebarOpen: true,
    setSidebar: (bool) => {},
    fullScreen: false,
    setFullScreen: (bool) => {},
})

export default SidebarContext
